import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'ui'
import { FormDescriptionText } from 'ui/components/form'
import { FieldAttributesSignature } from '.'
import { usePDFStore } from '../../../stores/pdf.store'

export const FieldSignatureReference: FieldAttributesSignature = ({
  field,
}) => {
  const updateField = usePDFStore((state) => state.updateField)
  const fields = usePDFStore((state) => state.fields)

  const recipientFields = usePDFStore((state) => {
    if (field.recipient_id)
      return state.fields.filter(
        (iterField) =>
          iterField.type === 'signature' &&
          iterField.recipient_id === field.recipient_id
      )

    return state.computed.currentRecipientFields.filter(
      (iterField) => iterField.type === 'signature'
    )
  })

  return (
    <div className='space-y-2'>
      <label className='font-bold text-sm'>Registrar fecha de la firma</label>
      <Select
        defaultValue={field.signature_field_id_to_record_date || ''}
        onValueChange={(value) =>
          updateField(field.id, {
            signature_field_id_to_record_date: value,
          })
        }
      >
        <SelectTrigger size='sm' className='w-full'>
          <SelectValue placeholder='Selecciona una opción' />
        </SelectTrigger>
        <SelectContent>
          {recipientFields.map((field) => {
            return (
              <SelectItem key={field.id} value={field.id}>
                {field.label}
              </SelectItem>
            )
          })}
        </SelectContent>
      </Select>
      <FormDescriptionText className='text-xs'>
        Por defecto, la fecha de la firma se registra en el momento en que el
        destinatario confirma sus acciones.
      </FormDescriptionText>
    </div>
  )
}
